import {useState} from "react";
import {useTranslation} from "react-i18next";
import moment from "moment-timezone";
import "moment-timezone";

import Spinner from "components/loaders/spinner";
import ModalEditUnload from "../unloads/ModalEditUnload";
import UnloadCell from "../unloads/UnloadCell";

const UnloadTimeModel = {
    item: null,
    date: null,
    time: null,
    value: 0,
    level: 0,
    exists: false,
};

const UnloadsTable = ({itemsShown, setItemsShown, isLoading = false, filters}) => {
    const {t: _Td} = useTranslation("datestimes");
    const {t: _Tt} = useTranslation("tables");
    const [showModal, setShowModal] = useState(false);
    const [modalItem, setModalItem] = useState(null);

    const handleClickEdit = (e) => {
        const tr = e.currentTarget.closest("tr");
        const unload = {...UnloadTimeModel};
        const date = e.currentTarget.dataset.date;
        unload.item = itemsShown[tr.dataset.idx];
        unload.item.idx = parseInt(tr.dataset.idx);
        unload.date = moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");

        const cell = e.currentTarget.querySelector(".data-cell");
        if (cell) {
            unload.value = cell.dataset.value;
            unload.time = cell.dataset.time;
            unload.level = cell.dataset.level;
            unload.exists = true;
            const unload_ = unload.item.unloads[date].find((u) => u.time === unload.time);
            unload.timestamp = unload_.timestamp;
        }
        setModalItem(unload);
        setShowModal(true);
    };

    // Generar matriz de calendario
    const startDate = moment(filters.current.start, "DD/MM/YYYY");
    const endDate = moment(filters.current.end, "DD/MM/YYYY");
    const calendar = [];
    let current = startDate.clone().startOf("week");
    let last = endDate.clone().endOf("week");
    while (current.isSameOrBefore(last)) {
        let week = [];
        for (let i = 0; i < 7; i++) {
            week.push(current.clone());
            current.add(1, "day");
        }
        calendar.push(week);
    }

    return (
        <>
            <div className="col-12">
                <hr className="mb-3" />
                {isLoading ? (
                    <Spinner text="Cargando datos..." />
                ) : (
                    <>
                        {!itemsShown || itemsShown.length === 0 ? (
                            <div className="alert alert-secondary text-center">No hay datos disponibles</div>
                        ) : (
                            <table className="table sticky-horizontal text-center" style={{tableLayout: "fixed"}}>
                                <thead>
                                    <tr>
                                        {calendar[0].map((day, idx) => (
                                            <th key={idx} className="sticky-top border-bottom-sticky">
                                                {_Td("days_name." + ((idx + 1) % 7))}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody id="data-list">
                                    {itemsShown.map((item, index) =>
                                        calendar.map((week, wIdx) => (
                                            <tr
                                                key={index + "-" + wIdx}
                                                data-idx={index}
                                                style={
                                                    wIdx === 0
                                                        ? {
                                                              borderTop: "2px solid #aaa",
                                                          }
                                                        : {}
                                                }>
                                                {week.map((day, dIdx) => {
                                                    const dateStr = day.format("DD-MM-YYYY");
                                                    const inRange = day.isSameOrAfter(startDate) && day.isSameOrBefore(endDate);
                                                    if (dateStr in item.unloads) {
                                                        return (
                                                            <td
                                                                key={dIdx}
                                                                className="border-start data-unloads"
                                                                style={{
                                                                    background: inRange ? "" : "#eee",
                                                                    cursor: inRange ? "pointer" : "default",
                                                                }}
                                                                data-date={dateStr}
                                                                data-uuid={item.uuid}>
                                                                <div style={{fontSize: "0.8em", color: "#444"}}>{day.date()}</div>
                                                                {inRange && dateStr in item.unloads ? (
                                                                    <UnloadCell
                                                                        item={item}
                                                                        date={{date: dateStr, day: day.date()}}
                                                                        handleClickEdit={handleClickEdit}
                                                                    />
                                                                ) : (
                                                                    <div style={{height: "32px"}}></div>
                                                                )}
                                                            </td>
                                                        );
                                                    } else {
                                                        return (
                                                            <td
                                                                key={dIdx}
                                                                className="border-start data-unloads"
                                                                style={{
                                                                    background: inRange ? "" : "#eee",
                                                                    cursor: inRange ? "pointer" : "default",
                                                                }}
                                                                data-date={dateStr}
                                                                data-uuid={item.uuid}
                                                                onClick={handleClickEdit}>
                                                                <div style={{fontSize: "0.8em", color: "#444"}}>{day.date()}</div>
                                                                <div style={{height: "32px"}}></div>
                                                            </td>
                                                        );
                                                    }
                                                })}
                                            </tr>
                                        )),
                                    )}
                                </tbody>
                            </table>
                        )}
                    </>
                )}
            </div>
            {showModal ? (
                <ModalEditUnload
                    show={showModal}
                    setShow={setShowModal}
                    item={modalItem}
                    itemsShown={itemsShown}
                    setItemsShown={setItemsShown}
                />
            ) : (
                ""
            )}
        </>
    );
};

export default UnloadsTable;
